import * as React from "react";
import {
  Page,
  Navbar,
  Block,
  List,
  ListItem,
  BlockTitle,
  Button,
  Col,
  Row,
  Icon,
} from "framework7-react";
import { removeToken } from "src/utils/utils";
import { COMPANY_NAME } from "src/utils/constants";
import { EventEmmiter } from "src/utils/events.js";

export default class PanelLeftPage extends React.Component {
  public state = {
    stores: [] as any[],
  };

  constructor(props: {} | Readonly<{}>) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  public logout() {
    const dialog = this.$f7?.dialog.preloader("Cerrando sesión");
    dialog?.open();

    setTimeout(() => {
      removeToken();
      dialog?.close();

      const form = document.querySelector("#login-form") as HTMLFormElement;
      form.reset();

      const loginPageDialog = document.querySelector(
        "#login-screen"
      ) as HTMLElement;

      this.$f7?.loginScreen.open(loginPageDialog);
    }, 600);
  }

  public changeMarket() {
    console.log("yeah");
  }

  public componentDidMount() {
    EventEmmiter.subscribe("stores-updated", (stores: any[]) => {
      this.setState({ stores });
      console.log(this.state);
    });
  }

  public render() {
    return (
      <Page panelLeftBreakpoint="400">
        <Navbar title={COMPANY_NAME} />

        {/* <List>
          <ListItem
            className={"bg-white"}
            title="Tienda:"
            smartSelect
            smartSelectParams={{ openIn: "popover" }}
          >
            <select
              onChange={this.changeMarket}
              name="mercado"
              defaultValue={["Compra 1"]}
            >
              {Stores.map((store: any) => {
                return (
                  <option key="0" value={store.name}>
                    {store.name}
                  </option>
                );
              })}
            </select>
          </ListItem>
        </List> */}
        <BlockTitle>Lista de Tiendas</BlockTitle>
        <List>
          <ListItem
            className={"bg-white"}
            key="0"
            link="/"
            title="Todas las Tiendas"
            view="#main-view"
            onClick={() => {
              // alert("ho");
            }}
            panelClose
          >
            <Icon slot="media" icon="icon icon-home" />
          </ListItem>
          {/* {this.state.stores.map((store: any) => {
            return (
              <ListItem
                className={"bg-white"}
                key="0"
                link="/"
                title={store.name}
                view="#main-view"
                onClick={() => {
                  // alert("ho");
                }}
                panelClose
              >
                <Icon slot="media" icon="icon icon-shopping-cart" />
              </ListItem>
            );
          })} */}

          <Block>
            <Row>
              <Col>
                <Button fill color="red" raised onClick={this.logout}>
                  Cerrar sesión
                </Button>
              </Col>
            </Row>
          </Block>
        </List>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PanelLeftPage.tsx